<template>
  <div class="inline-message" :class="type">{{message}}</div><!-- /.inline-message -->
</template>

<script>
import { validateInlineMessageType } from "@/helpers/validation";

export default {
  name: "InlineMessage",
  props: {
    type: {
      type: String,
      required: false,
      default: "default",
      validator: function(type) {
        return validateInlineMessageType(type);
      },
    },
    message: {
      type: String,
      required: true,
    },
  },
};
</script>
